var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.678,
    height: 39.925,
    viewBox: "0 0 38.678 39.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -0.121,
    cy: 0.735,
    r: 1.319,
    gradientTransform: "matrix(0.569, -0.822, 0.813, 0.562, -0.649, 0.222)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008ad1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#008ad1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#545199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#aa1761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#cd004b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#f3711b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb808"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2250",
    transform: "translate(-7652 113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M121.817,286.45h-7.261v-1.678a.925.925,0,0,0-.926-.918h-.4a.925.925,0,0,0-.926.918v1.678h-7.413v-1.678a.925.925,0,0,0-.926-.918h-.4a.925.925,0,0,0-.926.918v1.678H95.022A5,5,0,0,0,90,291.428v23.689a5.005,5.005,0,0,0,5.02,4.978h26.795a5.005,5.005,0,0,0,5.021-4.978V291.428A5.005,5.005,0,0,0,121.817,286.45Zm-26.795,2.388h7.623v.539a.925.925,0,0,0,.926.918h.4a.925.925,0,0,0,.926-.918v-.539h7.413v.539a.925.925,0,0,0,.926.918h.4a.925.925,0,0,0,.926-.918v-.539h7.261a2.6,2.6,0,0,1,2.613,2.59V298.5H92.41v-7.071A2.6,2.6,0,0,1,95.022,288.838Zm8.825,19.143v-7.829h9.679v7.829Zm9.679,1.653v8.074h-9.679v-8.074Zm-11.346-1.653H92.41v-7.829h9.771Zm13.013-7.829h9.237v7.829h-9.237ZM92.41,315.118v-5.484h9.771v8.074H95.022A2.6,2.6,0,0,1,92.41,315.118Zm29.407,2.591h-6.624v-8.074h9.237v5.484A2.6,2.6,0,0,1,121.817,317.708Z",
    transform: "translate(7561.998 -396.854)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2123",
    "data-name": "Group 2123",
    transform: "translate(7673.668 -90.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M8.5,0A8.5,8.5,0,1,1,0,8.5,16.461,16.461,0,0,1,1.141,4.246S5.25,0,8.5,0Z",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M4.638,1.488,6.681,3.531,2.245,7.966l-1.821.2A.383.383,0,0,1,0,7.744L.2,5.922,4.638,1.488Zm3.306-.3L6.985.225A.766.766,0,0,0,5.9.225l-.9.9L7.042,3.17l.9-.9A.766.766,0,0,0,7.944,1.184Z",
    transform: "translate(4.421 4.42)",
    fill: "#f2f2f2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.f5331b4286f0b64b8f282b6535e69a50.svg";
export { ForwardRef as ReactComponent };